import React from "react";
import CategoryTeam from "../CategoryTeam";
import { AdminFinanceProfile } from "./AdminFinance";

function AdminFinanceTeam() {
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 text-center gap-11">
      {AdminFinanceProfile.map((category) => (
        <CategoryTeam key={category.id} ourTeam={category} />
      ))}
    </div>
  );
}

export default AdminFinanceTeam;
